import React, { useRef, useMemo } from "react"
import { useNavigate } from "react-router"
import { Button, DatePicker, Form, Input, Upload, Select, Divider, Flex, InputNumber } from "antd"
import { useDispatch, useSelector } from "react-redux"

// Components
import showSecondarySidebar from "../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../components/Decoration/Page"

// Handlers
import { uploadHDLR } from "../../../../../handlers"

// Services Library
import { REDUX, TIME } from "../../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../services/redux/actions'

// Style
import styles from './index.module.css'

const { getBase64, handleBeforeUpload, UploadDriverICImage } = uploadHDLR;

const IncidentCUForm = ({
    data = {}
}) => {

    const title = data.title || 'Add New'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const user = useSelector(REDUX.reduxStoreWrapper('user'))
    const drivers = useSelector(REDUX.reduxStoreWrapper('drivers.byID'))
    const vehicles = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const loading = useSelector(REDUX.reduxStoreWrapper("style.loading.report"));

    const { uid } = user

    const onFinish = (e) => {

        const items = {
            ...e,
            uid: uid,
            drvid: e.drvname?.split('_')[0],
            plate: vehicles[e.vid]?.plate,
            incidentTime: TIME.parseTimestamp(e.incidentTime),
            attachments: icref.current
        }

        delete items.drvname

        switch(title) {
            case 'Add New': {
                dispatch(REDUX_ACTIONS.v3_drivers.create_incident_report_request(items, () => {
                    navigate(-1)
                }))

                break;
            }
            case 'Edit': {
                // dispatch(REDUX_ACTIONS.v3_drivers.update_driver_request(items, () => {
                //     navigate(`/management/driver`)
                // }))

                break;
            }
        }
    }

    // upload image
    const icref = useRef([])
    
    const handleChangeAttachment = (info) => {
        const { status, originFileObj, response = {} } = info.file;
        
        if(status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;

                icref.current = [ ...icref.current, url ]

            });
        }
    };

    const handleRemoveAttachment = ({ response }) => {
        const { url } = response
        
        icref.current = icref.current.filter(ic => ic !== url)
    }

    const newFileList = useMemo(() =>
        (data?.attachments || []).map((attachment, index) => {
            return {
                uid: `${index}`,
                name: attachment.split('/').pop(),
                status: 'done',
                url:attachment,
            };
    }).filter(Boolean), [data?.attachments]);


    return (
        <div className="page-container">
            <Page title={`${title} Incident Record`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 4 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        // ...data,
                        // rfid: data.icSerialNumber ? true : false,
                        // licenseExpiredAt: TIME.dayJS(data?.licenseExpiredAt),
                        company: data.company || uid,
                        performanceDeduction: 0
                    }}
                >
                    <Form.Item
                        label="Company Name"
                        name="company"
                        rules={[
                            {
                                required: true,
                                message: 'Please select company name!',
                            },
                        ]}
                    >
                        <Select size={'large'} options={[user].map(u => ({ label: u.name, value: u.uid }))} disabled/>
                    </Form.Item>
                    <Form.Item
                        label="Driver Name"
                        name="drvname"
                        rules={[
                            {
                                required: true,
                                message: 'Please input driver name!',
                            },
                        ]}
                    >
                        <Select 
                            size="large" 
                            showSearch
                            options={Object.values(drivers).map(u => ({ label: u.name, value: `${u.drvid}_${u.name}` })).sort((a, b) => a.label.localeCompare(b.label))} 
                            onChange={(e) => {
                                const drvid = e.split('_')[0]
                                const driver = drivers[drvid] || {}

                                form.setFieldsValue({
                                    contact: driver.contact,
                                    icNumber: driver.icNumber,
                                    drvid: drvid
                                })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Driver Contact"
                        name="contact"
                        rules={[
                            // {
                            //     required: true,
                            //     message: 'Please input driver contact!',
                            // },
                            // {
                            //     pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                            //     message: 'Invalid phone number format. Please enter a valid phone number!'

                            // }
                        ]}
                        >
                            <Input size="large" placeholder="60123456789"/>
                        </Form.Item>
                    <Form.Item
                        label="IC Number"
                        name="icNumber"
                        rules={[
                            // {
                            //     required: true,
                            //     message: 'Please input IC number!',
                            // },
                            {
                                pattern: /^\d+$/,
                                message: 'Please input only number'
                            },
                            // {
                            //     pattern: /^[0-9]{12}$/,
                            //     message: 'Invalid IC number. Must be a 12-digit IC number'

                            // }
                        ]}
                        >
                            <Input size="large" />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Plate"
                            name="vid"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input vehicle plate!',
                                },
                            ]}
                        >
                            <Select 
                                size="large" 
                                options={Object.values(vehicles).map(u => ({ label: u.plate, value: u.vid })).sort((a, b) => a.label.localeCompare(b.label))} 
                            />
                        </Form.Item>

                        <Divider />

                        <Form.Item
                            label={<><span style={{ color: 'red'}}>*&nbsp;</span>Date of Incident</>}
                        >
                            <Flex justify="space-between" >
                                <Form.Item
                                    name="incidentTime"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input incident date!',
                                        },
                                ]}>
                                    <DatePicker
                                        size='large'
                                        style={{ width: '22em' }}
                                        format="YYYY-MM-DD"
                                        // showTime
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Performance Deduction"
                                    name="performanceDeduction"
                                >
                                    <InputNumber min={0} max={100} size="large" style={{ width: '10em' }} />
                                </Form.Item>
                            </Flex>
                        </Form.Item>
                        <Form.Item
                            label="Location"
                            name="location"
                        >
                            <Input size="large" />
                        </Form.Item>
                        <Form.Item
                            label="Attachments"
                            name="attachments"
                        >
                            <Upload
                                // accept="video/*,image/*"
                                listType="picture-card"
                                customRequest={UploadDriverICImage}
                                beforeUpload={handleBeforeUpload}
                                onChange={handleChangeAttachment}
                                onRemove={handleRemoveAttachment}
                                defaultFileList={newFileList}
                            >
                                + Upload
                            </Upload>
                        </Form.Item>
                            <Form.Item
                                label="Description"
                                name="description"
                            >
                                <Input.TextArea style={{ height: 180, resize: 'none' }} size="large" />
                            </Form.Item>
                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} loading={loading} htmlType="submit">{title === 'Add New' ? 'Add' : 'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedIncidentCUForm = React.memo(IncidentCUForm);

export default showSecondarySidebar(false)(MemoizedIncidentCUForm);